<script>
  export default {
    methods: {
      imagePath (image, size) {
        return process.env.IMAGE_URL + '/' + size + '/' + image.contentUrl
      }
    }
  }
</script>
